module.exports = __webpack_public_path__ + "img/new-swift-booster-green-2023.2382d09e.svg";